"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getSpecies_1 = require("../helpers/getSpecies");
exports.switchAll = function (stream) {
    var C = getSpecies_1.getSpecies(stream);
    return new C(function (observer) {
        var activeSubscription;
        var rootIsComplete;
        var rootSubscription;
        rootSubscription = stream.subscribe({
            start: function (subscription) {
                rootSubscription = subscription;
            },
            next: function (inner) {
                try {
                    if (activeSubscription) {
                        activeSubscription.unsubscribe();
                    }
                    var innerIsComplete_1 = false;
                    var innerSub = C.from(inner).subscribe({
                        start: function (innerSubscription) {
                            activeSubscription = innerSubscription;
                        },
                        next: function (innerValue) {
                            observer.next(innerValue);
                        },
                        error: function (innerReason) {
                            observer.error(innerReason);
                        },
                        complete: function () {
                            innerIsComplete_1 = true;
                            activeSubscription = undefined;
                            if (rootIsComplete) {
                                observer.complete();
                            }
                        }
                    });
                    /* istanbul ignore next */
                    if (!innerIsComplete_1 && !activeSubscription) {
                        activeSubscription = innerSub;
                    }
                }
                catch (reason) {
                    observer.error(reason);
                }
            },
            error: function (reason) {
                observer.error(reason);
            },
            complete: function () {
                rootIsComplete = true;
                if (!activeSubscription) {
                    observer.complete();
                }
            }
        });
        return function () {
            rootSubscription.unsubscribe();
            if (activeSubscription) {
                activeSubscription.unsubscribe();
            }
        };
    });
};
//# sourceMappingURL=switchAll.js.map